import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 6rem;
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('30', '30', 'BOLD')};
  color: ${COLORS.BLACK};
  text-align: left;
`;
